<mat-form-field appearance="fill">
    <mat-label>Ricerca per nome </mat-label>
    <input matInput [formControl]="filtroRicerca">
    <mat-icon matPrefix>search</mat-icon>
</mat-form-field>
<nz-datatable [columns]="columns" [data]="data" [data_count]="data_count" [clickable]="!client"
    [default_sort]="table_config.sorting" (page_changed)="onPageChange($event)" (sort_changed)="onSortChange($event)">
</nz-datatable>